import React from 'react'

interface ContactBookIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const ContactBookIcon: React.FC<ContactBookIconProps> = ({
  color = '#888',
  gradient,
  width = 28,
  height = 30,
  alt = 'Contactbook icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 28 30'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        d='M24.615.65H6.112a2.744 2.744 0 00-2.743 2.743v2.49H1.624a.88.88 0 00-.872.872.88.88 0 00.872.872H3.37v6.707H1.624a.88.88 0 00-.872.872.88.88 0 00.872.872H3.37v6.818H1.513a.88.88 0 00-.872.872.88.88 0 00.872.872H3.37v2.046a2.744 2.744 0 002.743 2.743h18.503a2.744 2.744 0 002.744-2.743V3.378A2.74 2.74 0 0024.614.65zm1 26.052a.995.995 0 01-1 .998H6.112a.995.995 0 01-1-.998v-2.046h1.634a.88.88 0 00.872-.872.88.88 0 00-.872-.872H5.113v-6.818h1.744a.88.88 0 00.872-.872.88.88 0 00-.872-.872H5.113V7.643h1.744a.88.88 0 00.872-.872.88.88 0 00-.872-.872H5.113v-2.49c0-.555.444-.999.999-.999h18.503c.555 0 1 .444 1 1V26.7z'
      ></path>
      <path
        fill={gradient ? 'url(#grad1)' : color}
        d='M16.022 9.752c-2.854 0-5.185 2.362-5.185 5.28 0 2.933 2.268 5.248 5.17 5.248h.633v-1.253h-.634c-2.204 0-3.932-1.76-3.932-3.996 0-2.267 1.728-4.027 3.932-4.027 2.331 0 4.17 1.68 4.17 3.821 0 .84-.238 2.252-1.125 2.252-.54 0-.603-.27-.603-.57v-1.602c-.032-1.364-1.157-2.49-2.537-2.49a2.544 2.544 0 00-2.537 2.537 2.53 2.53 0 002.537 2.521c.444 0 .888-.142 1.269-.396l.079-.048c.19.809.824 1.269 1.791 1.269 1.634 0 2.395-1.808 2.395-3.488 0-2.823-2.379-5.058-5.423-5.058zm1.173 5.771l-.412.365c-.254.222-.587.364-.872.364-.713 0-1.284-.57-1.284-1.284 0-.73.57-1.284 1.284-1.284.714 0 1.284.57 1.284 1.284v.555z'
      ></path>
    </svg>
  )
}

export default ContactBookIcon
